import $ from "jquery";
import { getListCounts } from "../general/catalog";

export default function initWiloHeader() {
  const header = document.getElementById("wilo-header");
  if (!header) {
    return;
  }
  if (header.dataset.wiloHeaderInitialized) {
    return;
  }
  header.dataset.wiloHeaderInitialized = "true";

  const q = (sel) => header.querySelector(sel);
  const qAll = (sel) => header.querySelectorAll(sel);
  const hide = (el) => el?.setAttribute("aria-hidden", "true");
  const show = (el) => el?.setAttribute("aria-hidden", "false");
  const lock = () => document.body.classList.add("wilo-nav--locked");
  const unlock = () => document.body.classList.remove("wilo-nav--locked");

  const hamburger = q(".wilo-header__hamburger");
  const mobileNav = document.getElementById("wilo-mobile-nav");
  const countryModal = document.getElementById("wilo-country-modal");
  const overlay = document.querySelector(".wilo-header__overlay");
  const flyout = q("[data-flyout-panel]");
  const mobileTitle = mobileNav?.querySelector(
    ".wilo-header__mobile-nav-title",
  );
  const mobileLang = mobileNav?.querySelector("[data-mobile-lang]");

  let activeMenuKey = null;
  let mobileLevel = 1;
  let activeMobileMenu = null;
  let isCollapsed = false;
  let scrollTimer = null;

  // ===== DESKTOP FLYOUT =====
  const positionPanel = (panel, navBar) => {
    const r = navBar.getBoundingClientRect();
    Object.assign(panel.style, {
      top: r.bottom + "px",
      left: r.left + "px",
      right: innerWidth - r.right + "px",
    });
  };

  const closeFlyout = () => {
    activeMenuKey = null;
    hide(flyout);
    qAll(".wilo-header__nav-item").forEach((i) =>
      i.classList.remove("is-active"),
    );
    unlock();
  };

  const l2TitleLink = q(
    ".wilo-header__l2-title .wilo-header__flyout-title-link",
  );
  const l3TitleLink = q(
    ".wilo-header__l3-title .wilo-header__flyout-title-link",
  );

  qAll(".wilo-header__flyout-title-link").forEach(
    (/** @type {HTMLAnchorElement}*/ anchor) =>
      anchor.addEventListener("click", (e) => {
        e.stopPropagation();
        // this workaround is necessary as some random jquery event listener prevents
        // proper clicking on the title link...
        window.location.href = e.currentTarget.href;
      }),
  );

  /**
   * @param {string|undefined} key
   */
  const openFlyout = (key) => {
    if (!key) {
      console.warn("got empty key for opening the menu - aborting.");

      return;
    }

    if (activeMenuKey === key) {
      return closeFlyout();
    }
    activeMenuKey = key;
    if (!flyout) {
      return;
    }

    const link = q(`[data-menu="${key}"] .wilo-header__nav-link`);
    if (l2TitleLink && link) {
      l2TitleLink.textContent = link.textContent;
      l2TitleLink.href = link.href || "#";
    }

    if (l3TitleLink) {
      l3TitleLink.textContent = "";
    }

    flyout
      .querySelectorAll(".wilo-header__l2-list")
      .forEach((l) =>
        l.setAttribute(
          "aria-hidden",
          l.dataset.forMenu === key ? "false" : "true",
        ),
      );
    flyout.querySelectorAll(".wilo-header__l3-list").forEach(hide);
    flyout
      .querySelectorAll(".wilo-header__l2-link.is-active")
      .forEach((l) => l.classList.remove("is-active"));

    show(flyout);
    qAll(".wilo-header__nav-item").forEach((i) =>
      i.classList.toggle("is-active", i.dataset.menu === key),
    );
    lock();
    requestAnimationFrame(() =>
      positionPanel(flyout, q(".wilo-header__nav-bar")),
    );
  };

  // primary navigation links
  qAll(".wilo-header__nav-item").forEach((item) => {
    item.addEventListener("click", (e) => {
      // TODO: remove magic number
      if (innerWidth <= 991) {
        return;
      }

      if (item.hasAttribute("data-menu")) {
        e.preventDefault();
        openFlyout(item.dataset.menu);

        return;
      }

      const href = item.querySelector("a")?.href;

      if (!href) {
        console.error("primary menu entry has no submenu and no link - link does nothing.");

        return;
      }

      e.stopPropagation();
      // this workaround is necessary as some random jquery event listener prevents
      // proper clicking on the title link...
      window.location.href = href;
    });
  });

  // as we already have jquery we use this for simple event propagation
  $(flyout).on("mouseenter", ".wilo-header__l2-link", (e) =>
    showL3Menu(e.target),
  );

  // fly must be closeable "outside" the content area (left and right spaces)
  // @see https://ciao-adesso.atlassian.net/browse/WWE-513
  $(".wilo-header__flyout").click((e) => {
    if (e.target?.closest(".wilo-header__flyout-inner") == null) {
      closeFlyout()
    }
  });

  /**
   * @param {HTMLLinkElement} l2Link
   */
  function showL3Menu(l2Link) {
    l2Link
      .closest(".wilo-header__l2-list")
      ?.querySelectorAll(".wilo-header__l2-link")
      .forEach((l) => l.classList.remove("is-active"));
    flyout.querySelectorAll(".wilo-header__l3-list").forEach(hide);

    if (l2Link.dataset.showL3) {
      if (l3TitleLink) {
        l3TitleLink.textContent =
          l2Link.querySelector("span")?.textContent ?? "";
        l3TitleLink.href = l2Link.href || "#";
      }

      l2Link.classList.add("is-active");
      const l3 = flyout.querySelector(
        `[data-l3-id="${l2Link.dataset.showL3}"]`,
      );
      if (l3) {
        show(l3);
        l3.scrollTop = 0;
      }
    } else {
      if (l3TitleLink) {
        l3TitleLink.textContent = "";
      }
    }
  }

  q(".wilo-header__flyout-close")?.addEventListener("click", closeFlyout);

  // Toggling .is-collapsed shrinks the sticky header (meta bar collapses),
  // animated over $header-transition (0.3s). While that height above the
  // viewport is changing, browsers with scroll anchoring (Chrome/Firefox)
  // silently adjust scrollY to keep visible content in place, which can push
  // y back across the 30/80 threshold and re-trigger the opposite toggle -
  // collapsing/expanding forever. Prefer `overflow-anchor: none` to disable
  // that compensation where it's supported. Safari has no `overflow-anchor`
  // support (and no scroll anchoring to begin with), so as a fallback there
  // we instead lock out scroll handling for the duration of our own
  // transition, giving any scrollY change caused by our toggle time to
  // settle before we react to the next scroll event.
  // @see https://ciao-adesso.atlassian.net/browse/WWE-540
  const supportsOverflowAnchor =
    typeof CSS !== "undefined" && CSS.supports?.("overflow-anchor", "none");
  if (supportsOverflowAnchor) {
    document.documentElement.style.overflowAnchor = "none";
  }

  const COLLAPSE_TRANSITION_MS = 350; // $header-transition (0.3s) + buffer
  let scrollLockUntil = 0;

  const handleScroll = () => {
    if (!supportsOverflowAnchor && Date.now() < scrollLockUntil) {
      return;
    }

    const y = scrollY;
    if (!isCollapsed && y > 80) {
      isCollapsed = true;
      header.classList.add("is-collapsed");
      if (!supportsOverflowAnchor) {
        scrollLockUntil = Date.now() + COLLAPSE_TRANSITION_MS;
      }
    } else if (isCollapsed && y < 30) {
      isCollapsed = false;
      header.classList.remove("is-collapsed");
      if (!supportsOverflowAnchor) {
        scrollLockUntil = Date.now() + COLLAPSE_TRANSITION_MS;
      }
    }
  };
  addEventListener("scroll", () => {
    if (!scrollTimer)
      scrollTimer = setTimeout(() => {
        scrollTimer = null;
        handleScroll();
      }, 50);
  });

  // ===== MOBILE NAV =====
  const resetMobile = () =>
    mobileNav
      ?.querySelectorAll(
        ".wilo-header__mobile-l1,.wilo-header__mobile-l2,.wilo-header__mobile-l3",
      )
      .forEach(hide);

  const updateMobileUI = () => {
    const bar = mobileNav?.querySelector(".wilo-header__mobile-title-bar");
    mobileNav
      ?.querySelector(".wilo-header__mobile-settings-panel")
      ?.classList.remove("is-visible");
    if (mobileLevel === 1) {
      if (mobileTitle) {
        mobileTitle.textContent = "";
      }
      hide(bar);
      if (mobileLang) {
        mobileLang.style.display = "";
      }
    } else {
      show(bar);
      if (mobileLang) mobileLang.style.display = "none";
    }
  };

  const closeMobileNav = () => {
    if (!mobileNav) {
      return;
    }
    hide(mobileNav);
    hamburger?.setAttribute("aria-expanded", "false");
    unlock();
    overlay?.classList.remove("is-visible");
    resetMobile();
    mobileLevel = 1;
  };

  const openMobileNav = () => {
    if (!mobileNav) {
      return;
    }
    const navBar = q(".wilo-header__nav-bar");
    if (navBar) {
      positionPanel(mobileNav, navBar);
    }
    resetMobile();
    show(mobileNav.querySelector(".wilo-header__mobile-l1"));
    show(mobileNav);
    hamburger?.setAttribute("aria-expanded", "true");
    lock();
    overlay?.classList.add("is-visible");
    mobileLevel = 1;
    activeMobileMenu = null;
    updateMobileUI();
  };

  mobileNav?.addEventListener("click", (e) => {
    // on mobile only a click on the right "arrow" should open the sub menu
    if (!e.target?.closest(".wilo-header__mobile-nav-arrow")) {
      return;
    }

    const l1 = e.target.closest(".wilo-header__mobile-l1 [data-menu]");
    if (l1) {
      e.preventDefault();
      activeMobileMenu = l1.dataset.menu;
      resetMobile();
      show(
        mobileNav.querySelector(
          `.wilo-header__mobile-l2[data-for-menu="${activeMobileMenu}"]`,
        ),
      );
      if (mobileTitle) {
        mobileTitle.textContent = l1.querySelector("a")?.textContent ?? "";
      }
      mobileLevel = 2;
      updateMobileUI();

      return;
    }
    const l2 = e.target.closest(".wilo-header__mobile-l2 [data-show-l3]");
    if (l2) {
      e.preventDefault();
      resetMobile();
      show(
        mobileNav.querySelector(
          `.wilo-header__mobile-l3[data-l3-id="${l2.dataset.showL3}"]`,
        ),
      );
      if (mobileTitle) {
        mobileTitle.textContent = l2.querySelector("a")?.textContent ?? "";
      }
      mobileLevel = 3;
      updateMobileUI();
    }
  });

  const goBack = () => {
    resetMobile();
    if (mobileLevel === 3) {
      show(
        mobileNav?.querySelector(
          `.wilo-header__mobile-l2[data-for-menu="${activeMobileMenu}"]`,
        ),
      );
      const l1 = mobileNav?.querySelector(
        `.wilo-header__mobile-l1 [data-menu="${activeMobileMenu}"]`,
      );
      if (mobileTitle && l1) {
        mobileTitle.textContent = l1.querySelector("a")?.textContent ?? "";
      }
      mobileLevel = 2;
    } else if (mobileLevel === 2) {
      show(mobileNav?.querySelector(".wilo-header__mobile-l1"));
      mobileLevel = 1;
      activeMobileMenu = null;
    }
    updateMobileUI();
  };

  hamburger?.addEventListener("click", () => {
    mobileNav?.getAttribute("aria-hidden") === "false"
      ? closeMobileNav()
      : openMobileNav();
  });
  mobileNav
    ?.querySelector(".wilo-header__mobile-nav-close")
    ?.addEventListener("click", closeMobileNav);
  if (mobileTitle) {
    mobileTitle.style.cursor = "pointer";
    mobileTitle.addEventListener("click", () => {
      if (mobileLevel > 1) {
        goBack();
      }
    });
  }

  mobileNav
    ?.querySelector(".wilo-header__mobile-nav-settings")
    ?.addEventListener("click", () => {
      const panel = mobileNav.querySelector(
        ".wilo-header__mobile-settings-panel",
      );
      if (!panel) {
        return;
      }
      if (panel.classList.toggle("is-visible")) resetMobile();
      else if (mobileLevel === 1) {
        show(mobileNav.querySelector(".wilo-header__mobile-l1"));
      } else if (mobileLevel === 2) {
        show(
          mobileNav.querySelector(
            `.wilo-header__mobile-l2[data-for-menu="${activeMobileMenu}"]`,
          ),
        );
      }
    });

  // ===== COUNTRY MODAL =====
  const openCountryModal = () => {
    if (countryModal) {
      show(countryModal);
      lock();
    }
  };
  const closeCountryModal = () => {
    if (countryModal) {
      hide(countryModal);
      unlock();
    }
  };
  document.querySelectorAll('[data-action="open-country-modal"]').forEach((t) =>
    t.addEventListener("click", (e) => {
      e.preventDefault();
      openCountryModal();
    }),
  );
  countryModal
    ?.querySelector(".wilo-country-modal__close")
    ?.addEventListener("click", closeCountryModal);
  countryModal
    ?.querySelector(".wilo-country-modal__backdrop")
    ?.addEventListener("click", closeCountryModal);

  // ===== SHARED CLOSE =====
  const closeAll = () => {
    closeFlyout();
    closeMobileNav();
    closeCountryModal();
  };
  overlay?.addEventListener("click", closeAll);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });

  // ===== BADGE COUNTS =====
  const readListCounts = () => {
    if (typeof wiloconfig === "undefined") {
      return;
    }

    const counts = getListCounts(wiloconfig.amirada.country, localStorage);
    Object.entries(counts).forEach(([key, count]) => {
      header.querySelectorAll(`[data-flyout="${key}"]`).forEach((el) => {
        if (count > 0) {
          el.setAttribute("data-badge", count.toString());

          const iconCountElement = el.querySelector(".wilo-header__meta-icon-count");
          if (iconCountElement) {
            iconCountElement.textContent = count.toString();
          }
        }
      });
    });
  };

  addEventListener("listCountChanged", readListCounts);
  readListCounts();

  // ===== MOBILE LOCALE =====
  mobileLang?.querySelectorAll("[data-locale-toggle]").forEach((toggle) => {
    toggle.addEventListener("click", () => {
      const group = toggle.closest("[data-locale-group]"),
        opts = group?.querySelector("[data-locale-options]");
      if (!group || !opts) {
        return;
      }
      opts.setAttribute(
        "aria-hidden",
        group.classList.toggle("is-open") ? "false" : "true",
      );
    });
  });

  handleScroll();
}
